/* eslint-disable import/prefer-default-export */
import React from 'react';
import ReactIs from 'react-is';
import Footer from "./Footer.js";
export function renderComponentOrContent(Comp) {
  if (isValidElement(Comp)) {
    return Comp;
  }
  if (ReactIs.isValidElementType(Comp)) {
    return /*#__PURE__*/React.createElement(Comp, null);
  }
  return null;
}
export function renderFooter(activeStep) {
  if (activeStep?.onNext || activeStep?.onBack) {
    return /*#__PURE__*/React.createElement(Footer, null);
  }
  return null;
}
function isValidElement(el) {
  return typeof el === 'string' || el === null || /*#__PURE__*/React.isValidElement(el);
}